<script lang="ts">
  import { Activity, type Exercise } from '@/Common/ActivityFunctions';
  import { programTypeIcon } from '@/Common/constants';
  import { cn } from '@/lib/utils';
  import { getContext } from 'svelte';
  import type { MyFitnessStores } from '../stores';
  import { StrToProgramType } from '@/Util/utils';
  import XSSCircle from '../TrainingForecast/XSSCircle.svelte';
  import { TagWrapper } from '@/Common';
  import { ActivityTag } from '@/Common/ActivityTag';

  export let activity: Exercise;
  export let layoutType: 'vertical' | 'horizontal' = 'vertical'; // determines whether the image is rendered above the content or to the right of the content

  const myFitness = getContext<MyFitnessStores>('myFitness');
  const { trainingPlan } = myFitness;

  $: programType = StrToProgramType($trainingPlan?.program_type, $trainingPlan?.selected_mode);
  $: isRest = Activity.isRest(activity);
  $: isGoalEvent = Activity.isGoalEvent(activity);
  $: placeholderName = Activity.getPlaceholderName(activity);

  $: XSSDetails = activity.placeholder_xss_details ? {
    xss: activity.placeholder_xss_details.xss ?? 0,
    xlss: activity.placeholder_xss_details.xlss ?? 0,
    xhss: activity.placeholder_xss_details.xhss ?? 0,
    xpss: activity.placeholder_xss_details.xpss ?? 0,
  } : {
    xss: activity.xss ?? 0,
    xlss: activity.xlss ?? 0,
    xhss: activity.xhss ?? 0,
    xpss: activity.xpss ?? 0,
  };
  const completedXSS = {
    xss: 0,
    xlss: 0,
    xhss: 0,
    xpss: 0,
  }

  const activityTag = ActivityTag('small');
  $: activityTags = [
    activityTag.forecast(activity, true),
  ].filter((tag) => tag);
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class='w-full flex flex-row gap-0 rounded-sm border border-border bg-none border-dashed'
>
  <div class={cn('w-full flex flex-row items-center', layoutType == 'horizontal' ? 'pr-2' : '')}>
    <XSSCircle small primaryXSSDetails={completedXSS} primaryTitle={'Completed'} targetXSSDetails={XSSDetails} secondaryTitle={'Forecasted'}/>
    <div class="flex flex-col gap-1 p-1 flex-1 min-w-0">
      <div class="flex flex-row gap-1 items-center">
        {#if isGoalEvent}
          <i class={cn('fa-light text-black mr-1', programTypeIcon[programType])} />
        {:else if isRest}
          <i class="fa-light fa-sheep text-black"></i>
        {:else if activity.type}
          {@const typeLower = activity.type.toLowerCase()}
          {#if typeLower == 'ride' || typeLower == 'cycling' || typeLower == 'virtualride'}
            <i class="fa-light fa-bicycle text-black"></i>
          {:else if typeLower == 'run' || typeLower == 'running' || typeLower == 'hike' || typeLower == 'virtualrun'}
            <i class="fa-light fa-walking text-black"></i>
          {:else if typeLower == 'swim' || typeLower == 'swimming'}
            <i class="fa-light fa-swimmer text-black"></i>
          {/if}
        {/if}
        <h3 class="font-semibold m-0 text-xs truncate">
          {placeholderName}
        </h3>
      </div>
      <TagWrapper tags={activityTags} />
    </div>
  </div>
</div>
